"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowTransformerValidator = void 0;
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const types_1 = require("../types");
class RowTransformerValidator {
  constructor() {
    this._rowTransform = null;
    this._rowValidator = null;
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  static createTransform(transformFunction) {
    if (types_1.isSyncTransform(transformFunction)) {
      return (row, cb) => {
        let transformed = null;
        try {
          transformed = transformFunction(row);
        } catch (e) {
          return cb(e);
        }
        return cb(null, transformed);
      };
    }
    return transformFunction;
  }
  static createValidator(validateFunction) {
    if (types_1.isSyncValidate(validateFunction)) {
      return (row, cb) => {
        cb(null, {
          row,
          isValid: validateFunction(row)
        });
      };
    }
    return (row, cb) => {
      validateFunction(row, (err, isValid, reason) => {
        if (err) {
          return cb(err);
        }
        if (isValid) {
          return cb(null, {
            row,
            isValid,
            reason
          });
        }
        return cb(null, {
          row,
          isValid: false,
          reason
        });
      });
    };
  }
  set rowTransform(transformFunction) {
    if (!lodash_isfunction_1.default(transformFunction)) {
      throw new TypeError('The transform should be a function');
    }
    this._rowTransform = RowTransformerValidator.createTransform(transformFunction);
  }
  set rowValidator(validateFunction) {
    if (!lodash_isfunction_1.default(validateFunction)) {
      throw new TypeError('The validate should be a function');
    }
    this._rowValidator = RowTransformerValidator.createValidator(validateFunction);
  }
  transformAndValidate(row, cb) {
    return this.callTransformer(row, (transformErr, transformedRow) => {
      if (transformErr) {
        return cb(transformErr);
      }
      if (!transformedRow) {
        return cb(null, {
          row: null,
          isValid: true
        });
      }
      return this.callValidator(transformedRow, (validateErr, validationResult) => {
        if (validateErr) {
          return cb(validateErr);
        }
        if (validationResult && !validationResult.isValid) {
          return cb(null, {
            row: transformedRow,
            isValid: false,
            reason: validationResult.reason
          });
        }
        return cb(null, {
          row: transformedRow,
          isValid: true
        });
      });
    });
  }
  callTransformer(row, cb) {
    if (!this._rowTransform) {
      return cb(null, row);
    }
    return this._rowTransform(row, cb);
  }
  callValidator(row, cb) {
    if (!this._rowValidator) {
      return cb(null, {
        row,
        isValid: true
      });
    }
    return this._rowValidator(row, cb);
  }
}
exports.RowTransformerValidator = RowTransformerValidator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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